// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-perfil-ligth {
  background-color: #FF9045;
}

.bg-perfil-medium {
  background-color: #FF9045;
}

.bg-perfil-dark {
  background-color: #F47617;
}`, "",{"version":3,"sources":["webpack://./src/styles/perfilTrabajador.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ","sourcesContent":[".bg-perfil-ligth {\n    background-color: #FF9045;\n}\n\n.bg-perfil-medium {\n    background-color: #FF9045;\n}\n\n.bg-perfil-dark {\n    background-color: #F47617;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
